import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    UnorderedList,
    ListItem
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import NutrientTable from "./NutrientTable";

export default function AnalysisAccordion({
                                              strengths = [],
                                              deficits = [],
                                              recommendations = [],
                                              micros = [],
                                              numDates = 1
                                          }) {
    const { t } = useTranslation();

    /** Helper to render one accordion item if it has content */
    const renderSection = (title, items) =>
        items.length ? (
            <AccordionItem>
                <h3>
                    <AccordionButton>
                        <Box flex="1" textAlign="left">
                            {title}
                        </Box>
                        <AccordionIcon />
                    </AccordionButton>
                </h3>
                <AccordionPanel pb={4}>
                    {items.length ? (
                        <UnorderedList spacing={2}>
                            {items.map((it, i) => (
                                <ListItem key={i}>{it}</ListItem>
                            ))}
                        </UnorderedList>
                    ) : (
                        "—"
                    )}
                </AccordionPanel>
            </AccordionItem>
        ) : null;

    return (
        <Accordion allowToggle mb={8}>
            {renderSection(t("analysis.strengths"), strengths)}
            {renderSection(t("analysis.deficits"), deficits)}
            {renderSection(t("analysis.recommendations"), recommendations)}

            {/* micronutrient table, collapsed by default */}
            {micros.length > 0 && (
                <AccordionItem>
                    <h3>
                        <AccordionButton>
                            <Box flex="1" textAlign="left">
                                {t("analysis.detailedNutrients")}{" "}
                                <Box as="span" fontSize="sm" color="gray.500">
                                    ({t("analysis.dailyAverage")})
                                </Box>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h3>
                    <AccordionPanel pb={4}>
                        <NutrientTable micros={micros} numDates={numDates} />
                    </AccordionPanel>
                </AccordionItem>
            )}
        </Accordion>
    );
}